import { PageHeader } from "../components/page-header.tsx";
import { SearchPanel } from "../components/search.tsx";
import type { Router } from "../router.ts";

/** Full-page search; the rail panel hides on narrow screens in favor of this. */
export function SearchView(router: Router): Element {
  const page = (
    <main class="search-page">
      {PageHeader({ title: "Search" })}
      {SearchPanel(router)}
    </main>
  );
  return page;
}
